import { Pipe, PipeTransform } from '@angular/core';
import { ReportCohortPeriod } from '../../interfaces/reports';

@Pipe({
  name: 'reportCohortPeriod'
})
export class ReportCohortPeriodPipe implements PipeTransform {

  transform(value: ReportCohortPeriod): string {
    const values = {
      [ReportCohortPeriod.DAILY]: 'Diario',
      [ReportCohortPeriod.MONTHLY]: 'Mensal',
    };

    return values[value];
  }

}
